var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import styled from "styled-components";
import { Field, useMutation, useShowFlag } from "@atlassiansox/microscopekit";
import Spinner from "@atlaskit/spinner";
import { DatePicker } from "@atlaskit/datetime-picker";
import { UpdateWarGameExerciseMutation } from "../../../graphql";
export var ExerciseDueDate = function (_a) {
    var dueDate = _a.dueDate, exerciseId = _a.exerciseId, isDisabled = _a.isDisabled, exerciseName = _a.exerciseName;
    var showFlag = useShowFlag();
    var _b = __read(useMutation(UpdateWarGameExerciseMutation, {
        onError: function (e) {
            console.error(e.message);
            showFlag({ type: "error", title: "Error", message: e.message });
        }
    }), 2), mutate = _b[0], loading = _b[1].loading;
    var onDueDateChange = function (newDueDate) {
        mutate({
            variables: {
                exerciseID: exerciseId,
                updateExerciseInput: {
                    name: exerciseName,
                    endDate: newDueDate
                }
            }
        });
    };
    return (React.createElement(Container, null,
        React.createElement(SpinnerContainer, null, loading && React.createElement(Spinner, null)),
        React.createElement(DueDateContainer, null,
            React.createElement(Field, { label: "Due Date", name: "dueDate", isDisabled: isDisabled }, function (_a) {
                var fieldProps = _a.fieldProps;
                return (React.createElement(DatePicker, __assign({}, fieldProps, { value: dueDate !== null && dueDate !== void 0 ? dueDate : "", placeholder: "Select...", onChange: onDueDateChange })));
            }))));
};
var DueDateContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 10rem;\n"], ["\n  width: 10rem;\n"])));
var SpinnerContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 2rem;\n"], ["\n  width: 2rem;\n"])));
var Container = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-end;\n"], ["\n  display: flex;\n  align-items: flex-end;\n"])));
var templateObject_1, templateObject_2, templateObject_3;
